import { FormFieldState } from '@/common/form/FormFieldState';
import { FormStateBase } from '@/common/form';

export class UserDetailsFormStateUserEdit extends FormStateBase {
  firstName: FormFieldState = new FormFieldState();
  lastName: FormFieldState = new FormFieldState();

  constructor() {
    super();
    this.setForm(this);
  }
}
